const HEADER = 'CONTRACTID';
const MAX_CONTRACTS = 40;

/**
 * Validates a CSV of contract ids against the rules of
 * PATCH /payment/payment-plan/refresh-async (RTK-6366).
 * The API answers 400 without a documented reason, so the user gets the exact problem here.
 */
export function parseContractIdsCsv(text) {
  const lines = text.replace(/^\uFEFF/, '').split(/\r\n|\r|\n/);
  while (lines.length && lines[lines.length - 1].trim() === '') {
    lines.pop();
  }

  if (!lines.length) {
    return { contractIds: [], errors: ['El archivo está vacío.'] };
  }
  if (lines[0] !== HEADER) {
    return {
      contractIds: [],
      errors: [`La primera fila debe ser exactamente ${HEADER}, sin columnas adicionales.`],
    };
  }

  const rows = lines.slice(1);
  if (!rows.length) {
    return { contractIds: [], errors: ['El archivo no contiene contratos.'] };
  }

  const errors = [];
  if (rows.length > MAX_CONTRACTS) {
    errors.push(`Se admite un máximo de ${MAX_CONTRACTS} contratos por carga y el archivo tiene ${rows.length}.`);
  }

  const seen = new Set();
  rows.forEach((row, index) => {
    const rowNumber = index + 2;
    if (row.trim() === '') {
      errors.push(`Fila ${rowNumber}: está vacía.`);
    } else if (/[;,]/.test(row)) {
      errors.push(`Fila ${rowNumber}: debe tener una sola columna.`);
    } else if (row !== row.trim()) {
      errors.push(`Fila ${rowNumber}: tiene espacios al principio o al final.`);
    } else if (seen.has(row)) {
      errors.push(`Fila ${rowNumber}: el contrato ${row} está duplicado.`);
    }
    seen.add(row);
  });

  return { contractIds: errors.length ? [] : rows, errors };
}

/** Builds the file in the documented format, whatever line endings or BOM the original had. */
export function buildContractIdsCsv(contractIds) {
  return `${[HEADER, ...contractIds].join('\n')}\n`;
}
